const styles = theme => ({
  root: {
    fontSize: '12px' }
});

export default styles;

